import { Search } from "@mui/icons-material";
import {
  IconButton,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { Box } from "@mui/system";
import dayjs from "dayjs";
import React, { useContext, useState } from "react";
import { ApplicationContext } from "../../context/application_ctx";
import { font } from "../../styles/font";
import { TextFieldMA } from "../../styles/styledComponents";
import { theme } from "../../styles/theme";
import { IconBack } from "../../svgIcons/icons";

export const PaymentDetails = ({ tableView, setTableView }) => {
  const { paymentList } = useContext(ApplicationContext);
  const [searchedEmpQuery, setSearchedEmpQuery] = useState("");
 
//   let auditDetails = [
//     {
//       name: "Rahul Kumar",
//       purchasedOn: "29 December 2024",
//       expiredOn: "29 December 2024",
//       revokedOn: "05 January 2024",
//       switchedFrom: "Trial to Standard",
//     },
//   ];

  let result = []
  return (
    <>
      {/* <Box display='flex'  justifyContent='center' flex='1' flexWrap='nowrap' >

        <Box display='flex'  alignItems='center' flex='1' backgroundColor={theme.col_4} px={4} borderRadius='12px' height='130px'>

        <Box display='flex' flexDirection={'column'} justifyContent='center' gap='5px' >
        <Box display='flex'  alignItems='center'  gap='8px'>
        <Avatar {...stringAvatar('Rahul Kumar')}/>
        <Typography fontSize={font.size.fs_3} color={theme.col_2}>Rahul Kumar</Typography>

        </Box>
        <Box display='flex' flexDirection='column'  justifyContent='center'  gap='5px'>

        <Typography fontSize={font.size.fs_3} color={theme.col_3}>Created at</Typography>
        <Typography fontSize={font.size.fs_3} color={theme.col_3}>Valid upto</Typography>
        </Box>

        </Box>
        <Box display='flex' flexDirection={'column'} justifyContent='center' gap='5px' >

        <Typography fontSize={font.size.fs_3} color={theme.col_3}>Revoked at</Typography>
        <Typography fontSize={font.size.fs_3} color={theme.col_3}> Changed from</Typography>
        </Box>

        </Box>
       
        </Box> */}

      <Box
        display="flex"
        alignItems="center"
        flex="1"
        flexDirection="column"
        backgroundColor={theme.col_4}
        borderRadius="8px"
        border={"1px solid rgb(229, 234, 242)"}
        overflow="hidden"
      >
        <Box width="100%" display="flex" gap="5px" alignItems="center" px={1.4}>
          {tableView ? (
            <Box py={1}>
              <IconButton onClick={() => setTableView(0)}>
                <IconBack />
              </IconButton>
            </Box>
          ) : (
            <></>
          )}
          <TextFieldMA
            id="emp"
            type="search"
            defaultValue={searchedEmpQuery}
            // disabled
            onChange={(e) => setSearchedEmpQuery(e.target.value)}
            size="small"
            fullWidth
            placeholder="Search Employee"
            InputProps={{
              style: {
                border: "none",
              },
              startAdornment: (
                <InputAdornment>
                  <IconButton size="small">
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              background: grey[100],
              borderRadius: "32px",
              "& fieldset": { border: "none" },
              "&.MuiInputBase-formControl": {
                border: "none",
                outline: "none",
              },
            }}
          />
        </Box>
        <TableContainer sx={{ height: "537px",display:'flex',flexDirection:'column' }}>
          <Table className="tableEmployees" stickyHeader>
            <TableHead>
              <TableCell>Paid Amount</TableCell>
              <TableCell align="center">Number of Licence</TableCell>
              <TableCell align="center">Licence Type</TableCell>
              <TableCell align="center">Purchased On</TableCell>
              {/* <TableCell>Date</TableCell> */}
            </TableHead>
            <TableBody>
              {paymentList
                // ?.filter(
                //   (data, i) =>
                //     data.employeeEmail
                //       ?.toLowerCase()
                //       .includes(searchedEmpQuery) ||
                //     data?.paymentAmount?.toLowerCase()?.includes(searchedEmpQuery) ||
                //     data?.totalLicenses?.toLowerCase()?.includes(searchedEmpQuery)
                // )
                .slice(1)?.map((data,i ,finalResult) => {
                
                        result.push(finalResult);
                    return(

                  <TableRow>
                    <TableCell>
                      <Typography display="flex" alignItems="center" gap="12px">
                        {/* <Box
                          display="flex"
                          alignItems="center"
                          width="40px"
                          height="40px"
                          borderRadius="50px"
                          flexDirection="column"
                          justifyContent="center"
                          backgroundColor={stringToColor(data.employeeEmail)}
                        >
                          <Typography
                            fontFamily={font.family.fm_2}
                            fontSize={font.size.fs_3}
                            fontWeight="bold"
                            color={theme.col_4}
                            textTransform="capitalize"
                          >
                            {stringToArray(data.employeeEmail)}
                          </Typography>
                        </Box> */}
                        <Typography
              textTransform='capitalize'
              borderRadius="25px"
              color={theme.col_2}
              fontWeight="bold"
            //   backgroundColor={theme.col_14_alpha}
              fontSize={font.size.fs_3}
            >

                        &pound;{data?.paidAmount}
            </Typography>
                      </Typography>
                    </TableCell>
                    
                     <TableCell align="center"><Typography
              textTransform='capitalize'
              borderRadius="25px"
              color={theme.col_2}
              fontWeight="bold"
            //   backgroundColor={theme.col_14_alpha}
              fontSize={font.size.fs_3}
            >
                {data.totalLicenses}
                </Typography>
                </TableCell>
                <TableCell>
                <Typography display="flex" justifyContent="center" gap="12px">

                      <Typography display="flex" alignItems="center" gap="12px">
                    
                        <Typography
               display="flex"
               alignItems="center"
               width="fit-content"
               sx={{ whiteSpace: "nowrap" }}
               padding={"2px 8px"}
               justifyContent="center"
               height="25px"
               textTransform="capitalize"
               borderRadius="25px"
               color={theme.col_3}
               fontWeight="bold"
               backgroundColor={theme.col_14_alpha}
               fontSize={font.size.fs_4}
            >

                        {data?.isDemo ? 'Trial' : 'Standard'}
            </Typography>
                      </Typography>
                </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography display="flex" justifyContent="center">
                        <Typography
                          display="flex"
                          alignItems="center"
                          width="fit-content"
                          sx={{ whiteSpace: "nowrap" }}
                          padding={"2px 8px"}
                          justifyContent="center"
                          height="25px"
                          textTransform="capitalize"
                          borderRadius="25px"
                          color={theme.col_3}
                          fontWeight="bold"
                          backgroundColor={theme.col_14_alpha}
                          fontSize={font.size.fs_4}
                        >
                          {dayjs(data?.purchaseDate).format("DD -  MMMM - YYYY")}
                        </Typography>
                      </Typography>
                    </TableCell>
                   
                   
                  </TableRow>
                    )
})}
            </TableBody>
          </Table>
          {paymentList.slice(1)?.length === 0 || result?.length === 0 ? (
                <Box
                  display="flex"
                  width="100%"
                  alignItems="center"
                  justifyContent="center"
                  height="100%"
                  flexDirection="column"
                  flex="1"
                >
                  <Box
                    display="flex"
                    width="26%"
                    backgroundColor={theme.col_2_alpha}
                    height="80px"
                    borderRadius="13px"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Typography
                      fontFamily={font.family.fm_2}
                      color={theme.col_2}
                      textAlign="center"
                      fontSize={font.size.fs_5}
                      fontWeight="bold"
                    >
                      No Purchase Made Yet
                    </Typography>
                  </Box>
                </Box>
              ) : (
                ""
              )}
        </TableContainer>
      </Box>
    </>
  );
};
